import { render } from "./CitationModal.vue?vue&type=template&id=116cd81e&scoped=true"
import script from "./CitationModal.vue?vue&type=script&lang=js"
export * from "./CitationModal.vue?vue&type=script&lang=js"

import "./CitationModal.vue?vue&type=style&index=0&id=116cd81e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116cd81e"]])

export default __exports__